module.exports = __webpack_public_path__ + "img/Kanarski otoki.633e7d25.png";